import { useCallback, useEffect, useState } from 'react'

import { sanitize } from 'core-components/helpers/sanitize'

import { CYCLED_ERROR_COUNTER } from '../constants'

export const useInfinityLoopCheck = <T>(data: T[], keyField: string) => {
  const [counter, setCounter] = useState<number>(0)
  const [values, setValues] = useState<Array<string | number>>([])

  const resetValue = useCallback((value: string | number) => {
    setCounter((prev) => prev + 1)
    if (value) {
      setValues((prev) => [...new Set([...prev, value])])
    }
  }, [])

  const updateValue = useCallback(() => {
    setCounter(0)
    setValues([])
  }, [])

  useEffect(() => {
    if (counter === CYCLED_ERROR_COUNTER) {
      const validKeys = data.map((el) => el[keyField])
      console.error(
        sanitize(
          `core-components/library/dropdown received values “${values}” that are not in the dataset. onChange('') was triggered, but the parent did not update the value. This may cause an infinite update loop. Available values: ${validKeys}`
        )
      )
    }
  }, [counter, data, keyField, values])

  return { updateValue, resetValue }
}
